export const blockIconsContentCalculate = (
	<span className='material-symbols-outlined'>calculate</span>
);
